<template>
  <div>
    <h1 class="page-header">{{ $t('feetype.feeType') }}</h1>
    <ts-card>
      <ts-card-wrapper> </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.fee_type_name }}</td>
          <td>
            <span v-if="model.fee_type_id != record.fee_type_id">{{
              record.fee_type_description
            }}</span>
            <input
              v-model="model.fee_type_description"
              class="form-control"
              :class="{ 'is-invalid': errors.has('fee_type_description') }"
              type="text"
              :placeholder="$t('feetype.enteryourdescription')"
              v-if="model.fee_type_id == record.fee_type_id"
            />
          </td>
          <td>
            <span v-if="model.fee_type_id != record.fee_type_id">{{
              record.VAT_rate
            }}</span>
            <input
              v-model.number="model.VAT_rate"
              class="form-control"
              :class="{ 'is-invalid': errors.has('VAT_rate') }"
              type="number"
              step="any"
              :placeholder="$t('feetype.enterVATrate')"
              v-if="model.fee_type_id == record.fee_type_id"
            />
          </td>
          <td>
            <span v-if="model.fee_type_id != record.fee_type_id">{{
              record.WHT_GL_code
            }}</span>
            <input
              v-model.number="model.WHT_GL_code"
              class="form-control"
              :class="{ 'is-invalid': errors.has('WHT_GL_code') }"
              type="number"
              :placeholder="$t('feetype.enterWHTGLcode')"
              v-if="model.fee_type_id == record.fee_type_id"
            />
          </td>
          <td class="text-center">
            <ts-button
              v-if="model.fee_type_id == record.fee_type_id"
              class="btn-xs btn-primary mr-2"
              @click="update(record)"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fa fa-save" v-else></i>
            </ts-button>
            <ts-button
              @click="cancel"
              v-if="model.fee_type_id == record.fee_type_id"
              class="btn-xs btn-default"
            >
              <i class="fa fa-times"></i>
            </ts-button>
            <a
              v-if="model.fee_type_id != record.fee_type_id"
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'fee-type',
  data() {
    return {
      loading: false,
      errors: new Errors(),
      columns: [
        { name: this.$t('feetype.feeType') },
        { name: this.$t('feetype.description') },
        { name: this.$t('feetype.vatrate') },
        { name: this.$t('feetype.whtglcode') },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ],

      model: {
        fee_type_id: '',
        fee_type_description: '',
        VAT_rate: '',
        WHT_GL_code: ''
      }
    }
  },
  created() {
    this.fetchData()
    this.setEditData()
  },
  computed: {
    ...mapState('feeType', ['resources', 'pagination', 'edit_data'])
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('feeType/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('feeType/SET_EDIT_DATA', record)
      this.setEditData()
      this.$router.push({
        name: 'fee-type-edit',
        params: { id: record.fee_type_id }
      })
    },
    update(record) {
      record._deleting = true
      this.$store
        .dispatch('feeType/update', Object.assign({}, this.model))
        .then(response => {
          this.cancel()
          record._deleting = false
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          record._deleting = false
        })
    },
    cancel() {
      this.errors = new Errors()
      this.model = {
        fee_type_id: '',
        fee_type_description: '',
        VAT_rate: '',
        WHT_GL_code: ''
      }
      this.$router.push({ name: 'fee-type' })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model = {
          fee_type_id: this.edit_data.fee_type_id,
          fee_type_description: this.edit_data.fee_type_description,
          VAT_rate: this.edit_data.VAT_rate,
          WHT_GL_code: this.edit_data.WHT_GL_code
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name !== 'fee-type') {
      this.$store.commit('feeType/RESET_STATE')
      this.$store.commit('feeType/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>

<style lang="css" scoped>
table td {
	vertical-align : middle;
}
</style>
